import {Routes} from '@angular/router';
import {mapComponentResolver} from './shared/resolvers/map-component.resolver';
import {pointOfInterestListResolver} from './shared/resolvers/point-of-interest-list.resolver';
import {headerResolver} from './shared/resolvers/header.resolver';
import {eventIndexResolver} from './shared/resolvers/event-index.resolver';
import {goldenTipIndexResolver} from './shared/resolvers/golden-tip-index.resolver';
import {goldenTipResolver} from './shared/resolvers/golden-tip.resolver';
import {eventResolver} from './shared/resolvers/event.resolver';
import {HeaderVariant} from './enums/header-variant';
import {notFoundResolver} from './shared/resolvers/not-found.resolver';
import {storyResolver} from './shared/resolvers/story.resolver';
import {routeDetailResolver} from './shared/resolvers/route-detail.resolver';
import {homeComponentResolver} from './shared/resolvers/home-component.resolver';
import {routesIndexResolver} from './shared/resolvers/routes-index.resolver';
import {pointOfInterestResolver} from './shared/resolvers/point-of-interest.resolver';
import {resetServicesAfterShowGuard} from './shared/guards/reset-services-after-show.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/home/home.component').then(component => component.HomeComponent),
    resolve: {homeComponentResolver}
  },
  {
    path: 'kaart',
    loadComponent: () => import('./components/map/map.component').then(component => component.MapComponent),
    resolve: {mapComponentResolver}
  },
  {
    path: 'locaties',
    children: [
      {
        path: '',
        loadComponent: () => import('./components/point-of-interest/point-of-interest-list.component').then(component => component.PointOfInterestListComponent),
        resolve: {pointOfInterestListResolver}
      },
      {
        path: ':slug',
        loadComponent: () => import('./components/point-of-interest/point-of-interest-detail/point-of-interest-detail.component').then(component => component.PointOfInterestDetailComponent),
        resolve: {pointOfInterestResolver},
        canDeactivate: [resetServicesAfterShowGuard],
      },
    ]
  },
  {
    path: 'evenementen',
    children: [
      {
        path: '',
        loadComponent: () => import('./components/event/event-index/event-index.component').then(component => component.EventIndexComponent),
        resolve: [eventIndexResolver, headerResolver],
        data: {title: 'Evenementen'}
      },
      {
        path: ':slug',
        loadComponent: () => import('./components/event/event/event.component').then(component => component.EventComponent),
        resolve: {eventResolver, headerResolver},
        data: {headerVariant: HeaderVariant.SMALL},
        canDeactivate: [resetServicesAfterShowGuard],
      }
    ]
  },
  {
    path: 'gouden-tips',
    loadComponent: () => import('./components/golden-tips/golden-tips-index/golden-tips-index.component').then(component => component.GoldenTipsIndexComponent),
    resolve: [goldenTipIndexResolver, headerResolver],
    data: {title: 'Gouden tips'}
  },
  {
    path: 'gouden-tip/:slug',
    loadComponent: () => import('./components/golden-tips/golden-tip/golden-tip.component').then(component => component.GoldenTipComponent),
    resolve: {headerResolver, goldenTipResolver},
    data: {headerVariant: HeaderVariant.SMALL},
    canDeactivate: [resetServicesAfterShowGuard],
  },
  {
    path: 'routes',
    children: [
      {
        path: '',
        loadComponent: () => import('./components/routes/routes-index/routes-index.component').then(c => c.RoutesIndexComponent),
        resolve: [routesIndexResolver]
      },
      {
        path: ':slug',
        loadComponent: () => import('./components/route-details/route-details.component').then(c => c.RouteDetailsComponent),
        resolve: {routeDetailResolver, headerResolver},
        data: {headerVariant: HeaderVariant.SMALL},
        canDeactivate: [resetServicesAfterShowGuard],
      }
    ]
  },
  {
    path: 'verhaal/:slug',
    loadComponent: () => import('./components/story/story.component').then(component => component.StoryComponent),
    resolve: {headerResolver, storyResolver},
    data: {headerVariant: HeaderVariant.SMALL},
    canDeactivate: [resetServicesAfterShowGuard],
  },
  {
    path: 'settings',
    loadComponent: () => import('./components/settings/settings.component').then(component => component.SettingsComponent),
    resolve: {headerResolver},
    data: {title: 'Instellingen'}
  },
  {
    path: 'app',
    loadComponent: () => import('./components/pages/app-info/app-info.component').then(component => component.AppInfoComponent),
    resolve: {headerResolver},
    data: {title: 'Download de app!'}
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./components/pages/privacy-policy/privacy-policy.component').then(component => component.PrivacyPolicyComponent),
    resolve: {headerResolver},
    data: {title: 'Privacy Policy'}
  },
  {
    path: '**',
    loadComponent: () => import('./components/not-found/not-found.component').then(component => component.NotFoundComponent),
    resolve: {headerResolver, notFoundResolver},
    data: {headerVariant: HeaderVariant.SMALL}
  }
];
